import { createContext, useContext, RefObject } from 'react'

export const ScrollContext = createContext<RefObject<HTMLElement | null> | null>(null)

export function useScrollContainer() {
  return useContext(ScrollContext)
}
